import React, { useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Container } from '@mui/material';
import GoBackButton from 'components/shared/buttons/GoBackButton';
import SEOPageTitle from 'components/shared/SEOPageTitle';
import PerformanceHistory from 'components/performance/PerformanceHistory';
import PlayCoachView from 'components/play/coach/PlayCoachView';
import AppBarContext from 'context/AppBarContext';
import clientSlice from 'store/modules/client';
import { clientViewFields } from 'common/constants/query-fields/client';

function ClientPerformanceAdminView() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { setAppBarButton, setAppBarTitle } = useContext(AppBarContext);

  const client = useSelector((state) => state.client.data.viewClient);

  const clientName = client ? `${client.first_name} ${client.last_name}` : null;
  const pageTitle = clientName ? `Rendimiento de ${clientName}` : 'Rendimiento del cliente';
  // Cliente OTRIX Play: no tiene rendimientos dinámicos del entrenador; se ven y califican
  // sus resultados auto-reportados. El id del store solo aplica si coincide con la ruta.
  const isPlayClient = client && String(client.id) === String(id) && client.platform === 'otrix_play';

  useEffect(() => {
    dispatch(clientSlice.actions.view({ fields: clientViewFields, id }));
  }, [id, dispatch]);

  useEffect(() => {
    setAppBarButton(null);
    setAppBarTitle(pageTitle);
  }, [pageTitle, setAppBarButton, setAppBarTitle]);

  return (
    <>
      <SEOPageTitle title={pageTitle} />
      <Container maxWidth="xl" sx={{ pt: 2, pb: 0 }}>
        <Box sx={{ mb: 2 }}>
          <GoBackButton />
        </Box>
      </Container>
      {isPlayClient ? <PlayCoachView clientId={id} /> : <PerformanceHistory clientId={id} />}
    </>
  );
}

export default ClientPerformanceAdminView;
